import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Paper,
  Button,
  useTheme
} from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const UnderConstruction = ({ pageName }) => {
  const theme = useTheme();
  const { language } = useLanguage();
  
  return (
    <Box sx={{ py: 8, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="md">
        <Paper 
          elevation={3}
          sx={{ 
            p: 6, 
            textAlign: 'center',
            borderRadius: 2,
            background: `linear-gradient(45deg, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
            border: `1px solid ${theme.palette.divider}`
          }}
        >
          <ConstructionIcon sx={{ fontSize: 80, color: theme.palette.warning.main, mb: 2 }} />
          
          <Typography variant="h4" gutterBottom fontWeight="bold">
            {language === 'es' 
              ? `${pageName} - En construcción` 
              : `${pageName} - Under Construction`
            }
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 4, maxWidth: '80%', mx: 'auto' }}>
            {language === 'es'
              ? `Estamos trabajando para ofrecerte el mejor contenido en nuestra sección de ${pageName.toLowerCase()}. Esta página estará disponible próximamente.`
              : `We're working to bring you the best content in our ${pageName.toLowerCase()} section. This page will be available soon.`
            }
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={RouterLink}
            to="/"
          >
            {language === 'es' ? 'Volver a la página principal' : 'Back to Home'}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default UnderConstruction;
